import { useApiScope } from '../../scope';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { BASE_URL } from './helpers';
import { FormSubmissionResponse } from './types';

/**
 * Hook to fetch a single form submission by ID
 */
export const useFormSubmission = (submissionId: string | null | undefined) => {
  const { shareToken } = useApiScope();
  const url = submissionId ? `${BASE_URL}/${submissionId}` : null;

  const { data, error, isLoading, mutate } = useSWR<FormSubmissionResponse>(
    url,
    SWRFetcher({
      method: 'GET',
      shareToken,
    })
  );

  return {
    data,
    error,
    isLoading,
    mutate,
    submission: data?.formSubmission ?? null,
  };
};

